import { IThunkActionCreator } from '..';
import { sendFeedbackFrom } from '../../api/complaint';
import { IComplaintFeedbackBody } from '../../components/complaint/feedback_form';

export enum EFeedbackComplaint {
  default,
  loading,
  success,
  error,
}

export interface IFeedbackComplaintState {
  status: EFeedbackComplaint;
  complaintId: number | undefined;
}

export interface IFeedbackComplaintStateChanger {
  type: 'IFeedbackComplaintStateChanger';
  status: EFeedbackComplaint;
}

export interface IFeedbackComplaintStateSetComplaintId {
  type: 'IFeedbackComplaintStateSetComplaintId';
  complaintId: number;
}

export interface IFeedbackComplaintStateSetCanUserSeeFeedbackForm {
  type: 'IAddComplaintRequestFinished';
  getUserFeedback: boolean;
}

export type TFeedbackComplaintActions = IFeedbackComplaintStateChanger | IFeedbackComplaintStateSetComplaintId;

export function statusChanger(status: EFeedbackComplaint): IFeedbackComplaintStateChanger {
  return {
    type: 'IFeedbackComplaintStateChanger',
    status,
  };
}

export function setComplaintId(complaintId: number): IFeedbackComplaintStateSetComplaintId {
  return {
    type: 'IFeedbackComplaintStateSetComplaintId',
    complaintId,
  };
}

export function setCanUserSeeFeedbackForm(getUserFeedback: boolean): IFeedbackComplaintStateSetCanUserSeeFeedbackForm {
  return {
    type: 'IAddComplaintRequestFinished',
    getUserFeedback,
  };
}

/* istanbul ignore next */
export function sendFeedbackComplaint(body: IComplaintFeedbackBody): IThunkActionCreator<Promise<void>> {
  return (dispatch, getState, context) => {
    const { httpApi } = context;
    dispatch(statusChanger(EFeedbackComplaint.loading));

    return sendFeedbackFrom(httpApi, body)
      .then(() => {
        dispatch(statusChanger(EFeedbackComplaint.success));
      })
      .catch(() => {
        dispatch(statusChanger(EFeedbackComplaint.error));
      });
  };
}

/* istanbul ignore next */
export const defaultState: IFeedbackComplaintState = {
  status: EFeedbackComplaint.default,
  complaintId: undefined,
};

/* istanbul ignore next */
export function complaintFeedbackReducer(
  state: IFeedbackComplaintState = defaultState,
  action: TFeedbackComplaintActions,
) {
  switch (action.type) {
    case 'IFeedbackComplaintStateChanger':
      return {
        ...state,
        status: action.status,
      };

    case 'IFeedbackComplaintStateSetComplaintId':
      return {
        ...state,
        complaintId: action.complaintId,
      };

    default:
      return state;
  }
}
